/*
    Helper functions for a naive calender, starting in the year 1000
    leapyear every year divisable by 4; no other gregorian leapyear rules
*/

/*
  parses a fictional date in the format dd-mm-yyyy and returns an array [Y,M,D]
  e.g.: 21-08-1003 -> [1003, 8, 21]
*/
function parseDate(datestring) {
  const temp = datestring.split("-").map(number => parseInt(number));
  return [temp[2], temp[1], temp[0]];
}


function isValidDate(datearr) {
  // check if array with length 3
  if (!Array.isArray(datearr) || datearr.length !== 3)
    return false;

  //check if number array
  for (let i = 0; i < datearr.length; i++) {
    if (typeof datearr[i] !== "number" || isNaN(datearr[i]))
      return false;
  }

  if (datearr[0] < 1000)
    return false

  if (datearr[1] < 1 || datearr[1] > 12) {
    return false;
  }

  let daysofmonth = getDaycount_Month(datearr[0], datearr[1])
  if (datearr[2] < 1 || datearr[2] > daysofmonth) {
    return false;
  }

  return true
}



/*
  returns number of days in a specified month
  @param:month integer [1-12]
*/
function getDaycount_Month(year, month) {
  if (month === 2 && isNaiveLeapYear(year))
    return 29;
  month--;

  const monthLookupArr = [
    31, 28, 31, 30, 31, 30,
    31, 31, 30, 31, 30, 31]
  return monthLookupArr[month];
}


function isNaiveLeapYear(year) {
  return year % 4 === 0
}

function getDaycount_Year(year) {
  return isNaiveLeapYear(year) ? 366 : 365;
}

/*
  Calculates the number of the date, starting with 01-January-1000 as day 1
  e.g. calculateNumberOfDate([1001,1,1])=>367
*/
function calculateNumberOfCurrentDate(datearr) {
  if (!isValidDate(datearr)) {
    return -1;
  }

  const y = datearr[0];
  const m = datearr[1];
  const d = datearr[2];

  let daycounter = 0;

  for (let i = 1000; i < y; i++) {
    daycounter += getDaycount_Year(i);
  }
  for (let i = 1; i < m; i++) {
    daycounter += getDaycount_Month(y, i);
  }
  return daycounter + d;

}

/*
  Calculate the weekday of a given date-array
  output should mimic this calendar:
  http://www.kalenderland.com/online/jahreskalender-2008.php?year=1003&offset=2
  returns weekday as int from 0(=monday) to 6(sunday)
*/
function getWeekDay(datearr) {
  const kalenderlandOffset = 6;
  const absoluteDaycount = calculateNumberOfCurrentDate(datearr)
  return (absoluteDaycount + kalenderlandOffset) % 7;
}


// how many blank cells should be in the first calendar row before the 1st real day?
// e.g. if the month starts on a Thursday, there need to be 3 empty filler cells in row 1!
function getCalendarFillerDays_before(year = 1000, month = 1) {
  return getWeekDay([year, month, 1]);
}

function previousMonth(year, month) {
  const tempMonth = (month - 1 <= 0) ? 12 : month - 1;
  let tempyear = tempMonth === 12 ? year - 1 : year;

  if (tempyear < 1000) return [year, month]
  return [tempyear, tempMonth]
}
function nextMonth(year, month) {
  const tempMonth = (month + 1 >= 13) ? 1 : month + 1;
  let tempyear = tempMonth === 1 ? year+1 : year;

  return [tempyear, tempMonth]
}

export {
  getDaycount_Month,
  getDaycount_Year,
  isNaiveLeapYear,
  parseDate,
  isValidDate,
  calculateNumberOfCurrentDate,
  getWeekDay,
  getCalendarFillerDays_before,
  previousMonth,
  nextMonth
}